import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Home from './pages/Home';
import SignIn from './components/SignIn';
import UpdateNotification from './components/UpdateNotification';
import { LoadingSpinner } from './components/UIComponents';
import './firebase'; // Initialize Firebase

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-surface-50">
        <LoadingSpinner message="Loading..." />
      </div>
    );
  }

  return isAuthenticated ? children : <SignIn />;
};

// App Routes Component (needs to be inside AuthProvider)
const AppRoutes = () => {
  return (
    <Router>
      <div className="min-h-screen">
        <UpdateNotification />
        <Routes>
          <Route 
            path="/" 
            element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            } 
          />
        </Routes>
      </div>
    </Router>
  );
};

function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}

export default App;
